import React, { useContext, useState } from "react";
import "./EmailForm.scss";
import { simplyClick, validateEmail } from "../../helpers";
import ButtonSubmit from "../ButtonSubmit";
import InputGlobal from "../InputGlobal";
import {
  ERROR_EMAIL_ALREADY_USED,
  errorEventsEmail,
  IS_VISIBLE_CUSTOM_AUTOCOMPLETE,
  landingId,
} from "../../constants";
import CustomEmailAutoComplete from "../CustomEmailAutoComplete";
import { ContextProfileUser } from "../../lib/profileContext";
import Tooltip from "../Tooltip";
import LoaderEmail from "../LoaderEmail/index";
function EmailForm({ nextStep }) {
  const [errorEmail, setErrorEmail] = useState(null);
  const [loader, setLoader] = useState(false);
  const { data, setData } = useContext(ContextProfileUser);
  const [showTooltip, setShowTooltip] = useState(false);
  const [loaderTextMain, setLoaderTextMain] = useState("");
  const [loaderTextSub, setLoaderTextSub] = useState("");

  const handlerSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    setLoaderTextMain("Verifying your email...");
    setLoaderTextSub("This might take a moment.");

    const textTimeout = setTimeout(() => {
      setLoaderTextMain("Still verifying your email...");
      setLoaderTextSub("Thanks for your patience!");
    }, 3000);

    validateEmail(data.email, (result) => {
      clearTimeout(textTimeout);
      setLoader(false);
      setLoaderTextMain("");
      setLoaderTextSub("");
      const { status, error } = result;
      setLoader(false);
      if (!status && error) {
        const analyticsEvent = errorEventsEmail[error];
        if (analyticsEvent) {
          simplyClick(analyticsEvent);
        }
        setErrorEmail(error);
        return;
      }
      nextStep();
    });
  };

  const handleAddEmail = (e) => {
    setEmailValue(e.target.value);
  };

  const setEmailValue = (value) => {
    setErrorEmail(null);
    setShowTooltip(false);
    setData({ ...data, email: value });
  };

  const handleGetEmailParams = (e) => {
    e.preventDefault();
    const email = data?.email;
    simplyClick("cl_lnd_lt2_againemail_login");

    if (email) {
      window.location.href = `/login/?email=${encodeURIComponent(email)}`;
    }
  };

  return (
    <>
      {loader && (
        <LoaderEmail textMain={loaderTextMain} textSub={loaderTextSub} />
      )}
      <div className="email__form-wrapper">
        <div className="user__form-top">
          <h3>My email</h3>
        </div>
        <form
          className="form__email"
          onSubmit={handlerSubmit}
          autoComplete="off"
        >
          <div className="input__wrapper">
            <InputGlobal
              onChange={(e) => handleAddEmail(e)}
              placeholder={"Enter your real email address"}
              className={`input__global input__email ${
                errorEmail ? "input__error" : ""
              }`}
              name={"email"}
              type={"text"}
              value={data.email ? data.email : ""}
              autoComplete="email"
              onFocus={() => {
                setShowTooltip(true);
                simplyClick("cl_lnd_lt2_email_type_email");
              }}
              onBlur={() => setShowTooltip(false)}
            />
            {IS_VISIBLE_CUSTOM_AUTOCOMPLETE && (
              <CustomEmailAutoComplete
                errorEmail={errorEmail}
                errorCb={() => setErrorEmail(null)}
              />
            )}
            {errorEmail && (
              <p className="errorEmail">
                {errorEmail === ERROR_EMAIL_ALREADY_USED
                  ? "This email is already registered"
                  : errorEmail}
              </p>
            )}

            {errorEmail === ERROR_EMAIL_ALREADY_USED && (
              <div className="extra-info">
                <a
                  onClick={handleGetEmailParams}
                  id="log-in-email"
                  className="email__login"
                  href={`/login/?landing_id=${landingId}${
                    data?.email
                      ? `&email=${encodeURIComponent(data.email)}`
                      : ""
                  }`}
                >
                  Log in
                </a>
                <p className="email_login-text">&nbsp;or use another email</p>
              </div>
            )}

            <Tooltip
              text="We'll use this email for account verification and important notifications."
              showTooltip={showTooltip}
              className="email"
            />
          </div>
          <ButtonSubmit
            className={"button__global button__email"}
            text={"NEXT"}
          />
          <div className="progress__dots">
            <span className="active"></span>
            <span className="active"></span>
            <span className="active"></span>
            <span className="active"></span>
            <span className="active"></span>
            <span></span>
          </div>
        </form>
      </div>
    </>
  );
}

export default EmailForm;
